import React, { useState } from "react"
import { isEmpty } from "lodash"

import { toast } from "@kit/design/toast"

import { Celebration } from "./celebration"
import { PlanComparisonContent } from "./plan-comparison-content"
import { UnauthorizedUpgrade } from "./unauthorized-upgrade"

import { PlanComparisonProvider, usePlanComparisonContext } from "./context"
import { AddCardModal } from "../add-card-modal/add-card-modal"
import { PlanSwitchConfirmationModal } from "./plan-switch-confirmation-modal"

const PlanComparisonInner = ({
  title,
  description,
  afterCelebration = () => {},
  celebrationMessage = ""
}) => {
  const {
    activeModal,
    closeAllModals,
    currentPlan,
    plans,
    plansForPaymentForm,
    refreshAllowedActivities,
    setActiveModal,
    switchPlan,
    toPlan,
    MODALS
  } = usePlanComparisonContext()

  const [planSwitchInProgress, setPlanSwitchInProgress] = useState(false)

  if (isEmpty(plans)) return null

  const handlePlanSwitch = async () => {
    setPlanSwitchInProgress(true)

    try {
      await switchPlan({
        planId: toPlan.id,
        promoCode: toPlan.promo_code?.redemption_code
      })
      setActiveModal(MODALS.CELEBRATION)
    } catch (error) {
      toast({
        type: "error",
        text: "Sorry, we couldn't change your plan. If this error persists, please contact support."
      })
      closeAllModals()
    }

    setPlanSwitchInProgress(false)
  }

  const closeCelebration = () => {
    refreshAllowedActivities()
    closeAllModals()
    afterCelebration()
  }

  return (
    <>
      {activeModal === MODALS.UNAUTHORIZED && (
        <UnauthorizedUpgrade onClose={closeAllModals} />
      )}

      {activeModal === MODALS.COMPARISON && (
        <PlanComparisonContent title={title} description={description} />
      )}

      {activeModal === MODALS.PLAN_SWITCH_CONFIRMATION && (
        <PlanSwitchConfirmationModal
          label="Your new plan"
          onClose={closeAllModals}
          fromPlan={currentPlan}
          toPlan={toPlan}
          onConfirm={handlePlanSwitch}
          onCancel={closeAllModals}
          disableButton={planSwitchInProgress}
          tracking={{
            location: "plan_modal_comparison"
          }}
        />
      )}

      {activeModal === MODALS.PAYMENT && (
        <AddCardModal
          title={`Upgrade to ${toPlan.display_name}`}
          onClose={closeAllModals}
          paymentFormOptions={{
            handleSubscription: () => setActiveModal(MODALS.CELEBRATION),
            plans: plansForPaymentForm,
            modalOptions: { handleClose: closeAllModals }
          }}
          tracking={{
            location: "plan_modal_comparison",
            plan: toPlan.service_level
          }}
        />
      )}

      {activeModal === MODALS.CELEBRATION && (
        <Celebration
          afterCelebration={closeCelebration}
          message={celebrationMessage}
        />
      )}
    </>
  )
}

export const PlanComparison = props => {
  return (
    <PlanComparisonProvider {...props}>
      <PlanComparisonInner {...props} />
    </PlanComparisonProvider>
  )
}
